import axios from 'axios';
import BaseAPI from './base/base-api';

class TransferInvByTaxCodeAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'InvoiceBotsAPI';
    controllerName = 'transferinvbytaxcode';
}

export default new TransferInvByTaxCodeAPI();